import React, {useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'

import { firestore } from '../../../firebase'
import { dateInputFormatterShort } from '../../../helpers/dateFormatter';
import TeamsPickerReturnTeamDoc from '../../Admin/Team/TeamsPickerReturnTeamDoc';

import TeamsSelector from '../../Admin/Team/TeamsSelector';

function EditFixture() {

    const {id} = useParams()


    const [homeTeam, setHomeTeam] = useState("")
    const [awayTeam, setAwayTeam] = useState("")

    const [homeTeamObj, setHomeTeamObj] = useState()
    const [awayTeamObj, setAwayTeamObj] = useState()

    const [homeGoals, setHomeGoals] = useState(0);
    const [awayGoals, setAwayGoals] = useState(0)

    const [homeTeamLogo, setHomeTeamLogo] = useState("")
    const [awayTeamLogo, setAwayTeamLogo] = useState("")
    const [homeTeamId, setHomeTeamId] = useState("")
    const [awayTeamId, setAwayTeamId] = useState("")
    const [date, setDate] = useState("");
    const [time, setTime] = useState("18:00");
    const [season, setSeason] = useState("2020")
    const [status, setStatus] = useState("")

    const [added, setAdded] = useState(false);
    const [message, setMessage] = useState("")

    useEffect(() => {

        try {
            const fixtureRef = firestore.collection("fixtures").doc(id);

            fixtureRef.onSnapshot(doc => {
                const fixture = {id: doc.id, ...doc.data()}
                setHomeTeamId(fixture.home_team_id);
                setAwayTeamId(fixture.away_team_id);
                setHomeTeam(fixture.home_team);
                setAwayTeam(fixture.away_team);
                setHomeGoals(fixture.home_goals);
                setAwayGoals(fixture.away_goals);
                setHomeTeamLogo(fixture.home_team_logo);
                setAwayTeamLogo(fixture.away_team_logo);
                setDate(dateInputFormatterShort(fixture.date));
                setTime(fixture.fixture_start)

                setHomeTeamObj({
                    team_name: fixture.home_team,
                    id: fixture.home_team_id,
                    team_logo: fixture.home_team_logo

                })
                setAwayTeamObj({
                    team_name: fixture.away_team,
                    id: fixture.away_team_id,
                    team_logo: fixture.away_team_logo

                })

            })

        } catch (error) {
            
        }

    }, [id])

    async function editFixtureHandler(e) {
        e.preventDefault();

        try {
            const fixtureRef = firestore.collection("fixtures").doc(id);

            if (!date || !homeTeam || !awayTeam || !awayTeamLogo || !homeTeamLogo) {
                setMessage("Fyll ut alle feltene")
                return
            }

            const data = {

                date,
                fixture_start: time,
                home_team: homeTeam,
                away_team: awayTeam,
                home_goals: homeGoals,
                away_goals: awayGoals,
                home_team_id: homeTeamId,
                away_team_id: awayTeamId,
                home_team_logo: homeTeamLogo,
                away_team_logo: awayTeamLogo,
                season,
                status

            }
            fixtureRef.update(data)
            setAdded(true)
        } catch (error) {
            setAdded(false)
            setMessage(error.message)
        }

    }

    return (
        <form onSubmit={editFixtureHandler}>

            
            <label>Hjemmemål</label>
            <input type="number" value={homeGoals} onChange={e => setHomeGoals(e.target.value)} className="form-control mb-2" />
            <label>Bortemål</label>
            <input type="number" value={awayGoals} onChange={e => setAwayGoals(e.target.value)} className="form-control mb-2" />

            <label>Status for kamp (Ikke startet, startet, ferdig)</label>
            <select value={status} onChange={e => setStatus(e.target.value)} className="browser-default custom-select">
                <option>Velg status</option>
                <option value="not_started">Ikke startet</option>
                <option value="playing_now">Pågår</option>
                <option value="finished">Ferdig</option>
            </select>

            <label>Hjemmelag</label>
            <TeamsPickerReturnTeamDoc setTeam={setHomeTeamObj} team={homeTeamObj} />

            <label>Bortelag</label>
            <TeamsPickerReturnTeamDoc setTeam={setAwayTeamObj} team={awayTeamObj} />
            
            <label>Hjemmelag (Gjeldende: {homeTeam})</label>
            <TeamsSelector setTeamName={setHomeTeam} setTeamId={setHomeTeamId} setTeamLogo={setHomeTeamLogo} />

            <label>Bortelag (Gjeldende: {awayTeam})</label>
            <TeamsSelector setTeamName={setAwayTeam} setTeamId={setAwayTeamId} setTeamLogo={setAwayTeamLogo} />
            
            <label>Dato {date}</label>
            <input type="date" value={date} onChange={e => setDate(e.target.value)} className="form-control mb-2" />

            <label>Kampstart kl {time}</label>
            <input type="datetime-local" value={time} onChange={e => setTime(e.target.value)} className="form-control mb-2" />



            <label>Hjemmelag</label>
            <input value={homeTeam} onChange={e => setHomeTeam(e.target.value)} className="form-control mb-2" />

            <label>Bortelag</label>
            <input value={awayTeam} onChange={e => setAwayTeam(e.target.value)} className="form-control mb-2" />

            <label>Hjemmelag ID</label>
            <input value={homeTeamId} onChange={e => setHomeTeamId(e.target.value)} className="form-control mb-2" />

            <label>Bortelag ID</label>
            <input value={awayTeamId} onChange={e => setAwayTeamId(e.target.value)} className="form-control mb-2" />

            <label>Logo Hjemmelag</label>
            <img src={homeTeamLogo} alt="hometeamlogo" style={{maxWidth: "20px"}} /><br />

            <label>Logo bortelag</label>
            {awayTeamLogo && <img src={awayTeamLogo} alt="hometeamlogo" style={{maxWidth: "20px"}} />}<br />

            {added && <div className="alert alert-success">Lagt til!</div>}
            {message && <div className="alert alert-danger">{message}</div>}
            <button className="btn btn-primary btn-rounded">Legg til</button>

        </form>
    )

}
export default EditFixture